export const VISITOR_EVENTS = {
  // Authentication Events
  USER_FIRST_AUTHENTICATION: "user_first_authentication",
  USER_RETURNING_AUTHENTICATION: "user_returning_authentication",

  // Onboarding Events
  USER_BEGINS_ONBOARDING: "user_begins_onboarding",
  USER_COMPLETES_ONBOARDING: "user_completes_onboarding",

  // Demographic Events
  USER_DEMOGRAPHICS_DETECTED: "user_demographics_detected",

  // Page Events
  PAGE_VISITED: "page_visited",
  PAGE_TIME_SPENT: "page_time_spent",
} as const;

export const WIZARD_EVENTS = {
  // Wizard Step Timing
  WIZARD_STEP_COMPLETED: "wizard_step_completed",
} as const;

export interface PageVisitEventData {
  page_path: string;
  page_title: string;
  user_id?: string;
  is_authenticated: boolean;
  referrer?: string;
  [key: string]: unknown;
}

export type AnalyticsEventName =
  (typeof VISITOR_EVENTS)[keyof typeof VISITOR_EVENTS];
